<div class="backModal enCierre">
  <div class="close closeModal">
    <a title="cerrar" (click)="close()"><span class="cross"></span><span class="sr-only">cerrar</span></a>
  </div>
  <div class="aviso" id="tabs-content-gestion" style="align-items: center">
    <div class="tituloSearch">Esta accion requiere elevación:</div>
    <div class="loginInputWrap" [formGroup]="loginForm">
      <div class="form-group login">
        <div class="tit-form-group">
          <label for="usuario">{{ 'USUARIO' | translate }}</label>
        </div>
        <input formControlName="usuario" 
        [ngClass]="{'active-form' : isSelected(usuario)}" #usuario type="text" class="form-control" id="elevacion-usuario" category="ALFANUMERICO"
        (focus)="focusValue($event)"
        >
      </div>
      <div class="form-group login">
        <div class="tit-form-group">
          <label for="contrasena">{{'CONTRASENA' | translate }}</label>
        </div>
        <input formControlName="contrasena" #clave category="pago" type="password" class="form-control" id="elevacion-contrasena"
        [ngClass]="{'active-form' : isSelected(clave)}" category="ALFANUMERICO"
        (focus)="focusValue($event)">
      </div>
    </div>
    <ng-template #loading class="DetalleBox__noResultsMessage">
        <div class="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
    </ng-template>
    <div class="faturacion-fila">
      <div class="ticket-info">
        <div class="inputControl botones">
          <button type="button" value="cancelar" class="cancelar" (click)="close()">
            {{ 'CANCELAR' | translateV2 }}
          </button>
        </div>
      </div>
      <div class="ticket-info">
        <div class="inputControl botones">
          <button type="button" value="ACEPTAR" class="pagar aceptar" (click)="elevarUsuario()">
            <ng-container>
              {{ 'ENTRAR' | translate }}
            </ng-container>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="keyboardWrap">
    <ticketing-keyboard></ticketing-keyboard>
    <ticketing-numpad></ticketing-numpad>
  </div>

</div>